const getOr = require('lodash/fp/getOr');

function parseValueMovement(vm) {
  const p = path => getOr(null, path, vm);

  return {
    price: p('psMktPrc') || p('psAvaBal'),
    date: p('psMktPrcDte') || p('asOfDate'),
  };
}

module.exports = parseValueMovement;
